export default __webpack_public_path__ + "static/media/bannerDesktop.8a0a9bcd.png";